import { Button, Css, ModalBody, ModalFooter, ModalHeader, useModal } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useState } from "react";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { DimensionTypeCheckboxes } from "src/routes/bids/plan-based-bid-package/components/DimensionTypeCheckboxes";
import { PersonalizationGroupsField } from "src/routes/bids/plan-based-bid-package/components/PersonalizationGroupsField";
import {
  buildDimensions,
  buildPersonalizationDimensions,
  PlanBasedBidPackageBidPlanGroup,
} from "src/routes/bids/plan-based-bid-package/utils";

type BasePlanPriceDimensionsModalProps = {
  group: ObjectState<PlanBasedBidPackageBidPlanGroup>;
  dimensionResults: ConfigureBidGroupsStepQuery["potentialBidPlanDimensions"];
};

export function BasePlanPriceDimensionsModal(props: BasePlanPriceDimensionsModalProps) {
  const { group, dimensionResults } = props;
  const { closeModal } = useModal();
  const [selectedTypeIds, setSelectedTypeIds] = useState<string[]>(
    (group.dimensions.value ?? []).map((d) => d.globalOptionTypeId).filter((id): id is string => !!id),
  );
  const [selectedGroupIds, setSelectedGroupIds] = useState<string[]>(
    (group.dimensions.value ?? []).map((d) => d.globalOptionGroupId).filter((id): id is string => !!id),
  );

  function save() {
    const existing = group.dimensions.value ?? [];
    group.dimensions.set([
      ...buildDimensions(selectedTypeIds, existing, dimensionResults),
      ...buildPersonalizationDimensions(selectedGroupIds, existing, dimensionResults),
    ]);
    closeModal();
  }

  return (
    <>
      <ModalHeader>Base Plan Price Dimensions</ModalHeader>
      <ModalBody>
        <div css={Css.mb3.$}>Define the attributes to include as lines in your bid sheet.</div>
        <div css={Css.df.fdc.gap3.$}>
          <DimensionTypeCheckboxes
            dimensionResults={dimensionResults}
            selectedTypeIds={selectedTypeIds}
            onChange={setSelectedTypeIds}
          />
          <PersonalizationGroupsField
            dimensionResults={dimensionResults}
            selectedGroupIds={selectedGroupIds}
            onChange={setSelectedGroupIds}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Cancel" variant="tertiary" onClick={closeModal} />
        <Button label="Save" onClick={save} />
      </ModalFooter>
    </>
  );
}
